import React, { useState } from "react";
import Swal from "sweetalert2";
import { submitBillingDetails } from "../../../../api/Api";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import Loader from "../../../../components/loader/loader";
import "./billingTabs.css";
export default function BillingTabs({
  productId,
  setActiveTab,
  serviceId,
  onBillingSubmit,
  onComplete,
}) {
  const [billingData, setBillingData] = useState({
    serviceType: "Normal",
    packType: "",
    renewalType: "",
    pricePoint: "",
    graceDuration: "",
    suspensionPeriod: "",
    parking: "",
    billingType: "",
    freeTrialDuration: "",
    validity: "",
    chargingCarryForward: "no",
    eventId: "552", // Static value as per payload
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    
    // Required fields validation
    const requiredFields = {
      packType: 'Pack Type',
      renewalType: 'Renewal Type',
      pricePoint: 'Price',
      graceDuration: 'Grace Duration',
      suspensionPeriod: 'Suspension Period',
      parking: 'Parking',
      billingType: 'Billing Type',
      validity: 'Validity'
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!billingData[field]) {
        newErrors[field] = `${label} is required`;
      }
    });

    // Price validation
    if (billingData.pricePoint) {
      const price = parseFloat(billingData.pricePoint);
      if (isNaN(price) || price <= 0) {
        newErrors.pricePoint = 'Price must be greater than 0';
      }
    }

    // Number field validations
    const numberFields = ['graceDuration', 'parking', 'validity'];
    numberFields.forEach(field => {
      if (billingData[field]) {
        const value = parseInt(billingData[field]);
        if (isNaN(value) || value < 0) {
          newErrors[field] = 'Must be a positive number';
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBillingSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fill all required fields correctly',
      });
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        serviceId: serviceId,
        id: productId,
        billingType: billingData.billingType,
        renewalType: billingData.renewalType,
        packType: billingData.packType,
        graceDuration: billingData.graceDuration,
        chargingCarryForward: billingData.chargingCarryForward,
        validity: billingData.validity,
        pricePoint: billingData.pricePoint,
        eventId: billingData.eventId,
        freeTrialDuration: billingData.freeTrialDuration || null,
        suspensionPeriod: billingData.suspensionPeriod,
        parking: billingData.parking,
        maxChargePerDay: null,
        consentChannel: null,
        subRetry: null,
      };

      const response = await submitBillingDetails(payload);

      if (response?.statusDescription?.status === 200) {
        onBillingSubmit(response.productModel.renewalType);
        onComplete();
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Billing details saved successfully!",
        });
        setActiveTab("keyword");
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to save billing details",
        });
      }
    } catch (error) {
      console.error("Error submitting billing details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to save billing details",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
     {/* <div className="tab-content"> */}
      {isLoading && <Loader />}
      <div className="tab-pane active">
        <div className="row">
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Service Type<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value="Normal"
                disabled
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Pack Type<span className="text-danger">*</span>
              </label>
              <select
                className={`form-select ${errors.packType ? 'is-invalid' : ''}`}
                name="packType"
                value={billingData.packType}
                onChange={handleChange}
              >
                <option value="">Select Pack Type</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              {errors.packType && <div className="invalid-feedback">{errors.packType}</div>}
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Renewal Type<span className="text-danger">*</span>
              </label>
              <div className="position-relative">
                <select
                    className="form-select"
                  name="renewalType"
                  value={billingData.renewalType}
                  onChange={handleChange}
                >
                  <option value="">Select Renewal Type</option>
                  <option value="autoRenewal">Auto Renewal</option>
                  <option value="manualRenewal">Manual Renewal</option>
                </select>
                
              </div>
            {/* </div> */}
          </div>
          {console.log("billingData.pricePoint", billingData)}
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Price<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="pricePoint"
                value={billingData.pricePoint}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow empty value for initial typing
                  if (value === '' || value === '0.') {
                    handleChange(e);
                    return;
                  }

                  // Convert to number and validate
                  const numValue = parseFloat(value);
                  if (!isNaN(numValue) && numValue >= 0 && numValue <= 999999) {
                    // Ensure only 2 decimal places
                    if (value.includes('.') && value.split('.')[1]?.length > 2) {
                      return;
                    }
                    handleChange(e);
                  }
                }}
                step="0.01"
                min="0.01"
                max="999999"
                placeholder="Enter Price"
                onWheel={(e) => e.target.blur()}
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Grace Duration(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="graceDuration"
                value={billingData.graceDuration}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Grace Duration"
                onWheel={(e) => e.target.blur()}
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Suspension Period<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="suspensionPeriod"
                value={billingData.suspensionPeriod}
                onChange={handleChange}
              >
                <option value="">Select Suspension Period</option>
                <option value="3Days">3 Days</option>
                <option value="7Days">7 Days</option>
              </select>
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Parking(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="parking"
                value={billingData.parking}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Parking Days"
                onWheel={(e) => e.target.blur()}
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Billing Type<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="billingType"
                value={billingData.billingType}
                onChange={handleChange}
              >
                <option value="">Select Billing Type</option>
                <option value="Package">Package</option>
                <option value="Usage">Usage</option>
              </select>
              
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>Free Trial Duration(In Days)</label>
              <input
                type="number"
                className="form-control"
                name="freeTrialDuration"
                value={billingData.freeTrialDuration}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Free Trial Duration"
                onWheel={(e) => e.target.blur()}
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>
                Validity(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="validity"
                value={billingData.validity}
                  onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Validity"
                onWheel={(e) => e.target.blur()}
              />
            {/* </div> */}
          </div>
          <div className="form-group col-md-3">
            {/* <div className="form-group"> */}
              <label>Carry Forward Charging</label>
              <div className="mt-2">
                <input
                  type="radio"
                  name="chargingCarryForward"
                  value="yes"
                  checked={billingData.chargingCarryForward === "yes"}
                  onChange={handleRadioChange}
                />{" "}
                Yes
                <input
                  type="radio"
                  name="chargingCarryForward"
                  value="no"
                  checked={billingData.chargingCarryForward === "no"}
                  onChange={handleRadioChange}
                  className="ml-3"
                />{" "}
                No
              </div>
            {/* </div> */}
          </div>
        </div>

        {/* <div className="row mt-3">
          <div className="col-md-3">
            <div className="form-group">
              <label>
                Grace Duration(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="graceDuration"
                value={billingData.graceDuration}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Grace Duration"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                Suspension Period<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="suspensionPeriod"
                value={billingData.suspensionPeriod}
                onChange={handleChange}
              >
                <option value="">Select Suspension Period</option>
                <option value="3Days">3 Days</option>
                <option value="7Days">7 Days</option>
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                Parking(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="parking"
                value={billingData.parking}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Parking Days"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                Billing Type<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="billingType"
                value={billingData.billingType}
                onChange={handleChange}
              >
                <option value="">Select Billing Type</option>
                <option value="Package">Package</option>
                <option value="Usage">Usage</option>
              </select>
              
            </div>
          </div>
        </div> */}

        {/* <div className="row mt-3">
        
          <div className="col-md-3">
            <div className="form-group">
              <label>Free Trial Duration(In Days)</label>
              <input
                type="number"
                className="form-control"
                name="freeTrialDuration"
                value={billingData.freeTrialDuration}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Free Trial Duration"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                Validity(In Days)<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                name="validity"
                value={billingData.validity}
                  onChange={(e) => {
                  const value = e.target.value;
                  // Allow only positive integers up to 4 digits
                  if (value === '' || (
                    Number.isInteger(Number(value)) && 
                    value >= 0 && 
                    value.toString().length <= 4
                  )) {
                    handleChange(e);
                  }
                }}
                onKeyPress={(e) => {
                  // Prevent decimal point and negative signs
                  if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="9999"
                placeholder="Enter Validity"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Carry Forward Charging</label>
              <div className="mt-2">
                <input
                  type="radio"
                  name="chargingCarryForward"
                  value="yes"
                  checked={billingData.chargingCarryForward === "yes"}
                  onChange={handleRadioChange}
                />{" "}
                Yes
                <input
                  type="radio"
                  name="chargingCarryForward"
                  value="no"
                  checked={billingData.chargingCarryForward === "no"}
                  onChange={handleRadioChange}
                  className="ml-3"
                />{" "}
                No
              </div>
            </div>
          </div>
        </div> */}

        <div className="row mt-4">
          <div className="col-md-12 d-flex justify-content-between buttons_divs">
            <button
              type="button"
              className="btn btn-secondary mr-2"
              onClick={() => setActiveTab("productDetails")}
            >
              Previous
            </button>
            <div>
              {/* <button
                type="button"
                className="btn btn-light mr-2"
                onClick={() => {
                  onComplete();
                  setActiveTab("keyword");
                }}
              >
                Skip
              </button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleBillingSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span className="ms-2">Saving...</span>
                  </>
                ) : (
                  "Save & Continue"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
     {/* </div> */}
    </>
  );
}
